import React from 'react'
import Scrollbars from 'react-scrollbars-custom'

import i18n from 'live/services/i18n'

import { IAsset } from '../../types'
import { FilteredSearch } from '../FilteredSearch/FilteredSearch'
import { AssetSelectorStyledContianer } from './styles'

interface Props {
    assets: IAsset[]
    selectedAsset: IAsset
    onAssetSelect: (asset: IAsset) => void
    onSearchClick: (value: string) => void
}

export const AssetSelector: React.FC<Props> = ({ assets, selectedAsset, onAssetSelect, onSearchClick }) => {
    return (
        <AssetSelectorStyledContianer>
            <div className="title">{i18n('Select Resource')}</div>
            <FilteredSearch onSearch={input => onSearchClick(String(input))} />
            <Scrollbars style={{ height: 'calc(100% - 86px)' }}>
                {assets.map((asset, idx) => (
                    <div
                        className={`asset ${selectedAsset?.id === asset?.id ? 'selected' : ''}`}
                        key={`${asset?.id}-${idx}`}
                        onClick={() => onAssetSelect(asset)}
                    >
                        <div className="asset-type">{asset?.assetType?.name ?? 'RESOURCE TYPE'}</div>
                        <div className="asset-name">{asset?.name ?? 'RESOURCE NAME'}</div>
                    </div>
                ))}
            </Scrollbars>
        </AssetSelectorStyledContianer>
    )
}
